import {
  ChangeDetectorRef,
  Component,
  HostListener,
  ViewChild,
  ViewContainerRef
} from '@angular/core';

import { CtrlBaseComponent } from '../ctrl-base.component';
import { breakpoints } from '../../environments/environment.breakpoints';

@Component({
  selector: 'ct-panel',
  templateUrl: './ct-panel.component.html',
  styleUrls: ['./ct-panel.component.css'],
  host: {
    '[id]': 'getId()',
    '[hidden]': 'getHidden()'
}
})
export class CtPanelComponent extends CtrlBaseComponent {

  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;
  @ViewChild('targetButton', {read: ViewContainerRef }) targetButton: ViewContainerRef;

  //ATTRIBUTES
  private panelType: string = 'container';
  private description: string;
  private title: string;
  private textAlign: string = 'flex-start';
  
  //util
  public isMediumSize : boolean = false;
  public isSmallSize : boolean = false;
  public isExtraSmall : boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.manageWindowResizing(window.innerWidth);
     }


  constructor(private cdr: ChangeDetectorRef) {
    super();
  }
  ngOnInit(): void {
    super.ngOnInit();
    this.manageWindowResizing(window.innerWidth);
  }
  ngAfterViewInit() {
    this.paintChildren(this.getMetaData(), this.target);
    this.manageWindowResizing(window.innerWidth);
  }
  getStyleTextAlign() {
    const textAlign = this.getTextAlign();
    if (textAlign === 'flex-start') {
      return {'align-items': 'flex-start'};
    } else if (textAlign === 'center') {
      return {'align-items': 'center'};
    } else if (textAlign === 'flex-end') {
      return {'align-items': 'flex-end'};
    } else {
      //default case si es algo diferente de los casos anteriores.
      return {'align-items': 'flex-start'};
    }
  }
  private manageWindowResizing(width: number) {
    this.isSmallSize = width < breakpoints.L && width >= breakpoints.M;
    this.isExtraSmall = width >= breakpoints.S && width < breakpoints.M;
    this.isMediumSize = width >= breakpoints.L;
    this.cdr.detectChanges();
  }

  //PROPERTIES
  getPanelType() { return this.panelType };
  getTitle(): string {return this.title};
  getDescription(): string {return this.description};
  getTextAlign(): string {return this.textAlign};

  setPanelType(panelType: string) {
    if (panelType === 'container' || panelType === 'action') {
      this.panelType = panelType;
    } else {
     this.panelType = 'container'
    }
  }
    setDescription(descripcion: string) {this.description = descripcion};
  setTitle(title: string) {this.title = title};
  setTextAlign(textAlign : string) {this.textAlign = textAlign};
}
